import { Component, OnInit } from '@angular/core';
import { CArticle } from '../../../models/article.models/article.model';
import { API_ServerAddress } from '../../../MyAppCommonConfig';
import { ArticleService } from '../../../services/article.service';
import { CArticleSearchModel } from '../../../models/article.models/articleSearchModel.model';
import { CCompanyInfoViewModel } from '../../../models/commonInformation.models/commonInformation.model';
import { CommonInformationService } from '../../../services/commonInformation.service';
import { CCommonPage } from '../../../models/page.models/commonPage.model';
import { CommonPageService } from '../../../services/commonPage.service';
import { Title, Meta } from '@angular/platform-browser';
import { CCompanyEquipment } from 'src/app/models/galery.models/companyEquipment.model';
import { CompanyEquipmentService } from 'src/app/services/companyEquipment.service';
import { CFAQ } from 'src/app/models/faq.models/faq.model';
import { FAQService } from 'src/app/services/faq.service';
import { CPartnerOrganization, CPartnerOrganizationSlideShowViewModel } from 'src/app/models/company.models/partnerOrganization.model';
import { PartnerOrganizationService } from 'src/app/services/partnerOrganization.service';


@Component({
    selector: 'home',
    templateUrl: 'home.component.html'
})
export class HomeComponent implements OnInit {
    ngOnInit(): void {
        this.GetCommonPage();
        this.GetCommonInfo();
        this.GetArticleArray();
        this.GetCompanyEquipmentArray();
        this.GetFAQArray();
        this.GetPartnerOrganizationArray();
    }

    commonPage: CCommonPage = new CCommonPage();
    id: string = 'HomeIndex';
    commonInformation: CCompanyInfoViewModel = new CCompanyInfoViewModel();
    articleArray: CArticle[] = [];
    companyEquipmentArray: CCompanyEquipment[] = [];
    faqArray: CFAQ[] = [];
    partnerOrganizationArray: CPartnerOrganization[] = [];
    insuranceSlideShowArray: CPartnerOrganizationSlideShowViewModel[]=[];
    ApiServiceAddress: string;

    constructor(private commonPageService: CommonPageService, private commonInformationService: CommonInformationService,
        private articleService: ArticleService, private companyEquipmentService: CompanyEquipmentService, private faqService: FAQService,
        private partnerOrganizationService: PartnerOrganizationService, private titleService: Title, private metaService: Meta) {

        this.ApiServiceAddress = API_ServerAddress;
    }

    SetPageMetaData(model: CCommonPage) {
        this.titleService.setTitle(model.fMetaTitle);
        this.metaService.updateTag({ name: 'description', content: model.fMetaDescription });
        this.metaService.updateTag({ name: 'keywords', content: model.fMetaKeywords });
    }

    GetCommonPage() {
        this.commonPageService.GetById(this.id)
            .subscribe((data: CCommonPage) => {
                this.commonPage = data;
                this.SetPageMetaData(data);
            });
    }

    GetCommonInfo() {
        this.commonInformationService.GetInfo()
            .subscribe((data: CCompanyInfoViewModel) => this.commonInformation = data);
    }

    GetArticleArray() {
        let searchModel: CArticleSearchModel = new CArticleSearchModel();
        searchModel.OrderByDESC = 'fId';
        searchModel.Fetch = 4;
        searchModel.Offset = 0;

        this.articleService.GetList(searchModel).subscribe((data: CArticle[]) => this.articleArray = data);
    }

    GetCompanyEquipmentArray() {
        this.companyEquipmentService.GetList().subscribe((data: CCompanyEquipment[]) => this.companyEquipmentArray = data);
    }

    GetFAQArray() {
        this.faqService.GetList().subscribe((data: CFAQ[]) => this.faqArray = data);
    }

    GetPartnerOrganizationArray() {
        this.partnerOrganizationService.GetList().subscribe((data: CPartnerOrganization[]) => {
            this.partnerOrganizationArray = data;

            this.MakeInsuranceSlides(data);
        });
    }

    MakeInsuranceSlides(data: CPartnerOrganization[]) {
        if (data.length > 0) {
            var daste = 8;
            var baghimande = data.length % daste;
            var needSlide = (data.length - baghimande) / daste;
            if (needSlide > 0) {
                for (var i = 0; i < needSlide; i++) {
                    var list : CPartnerOrganization[] = data.slice(i * daste, ((i * daste) + daste));
                    var VM:CPartnerOrganizationSlideShowViewModel=new CPartnerOrganizationSlideShowViewModel();
                    VM.ListPartnerOrganizations=list;
                    this.insuranceSlideShowArray.push(VM);
                }
            }
        }
    }
}